/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

var prefixCls = 'shy__loading-bar';
export default {
  props: {
    percent: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: 'success'
    },
    isShow: {
      type: Boolean,
      required: true
    },
    color: {
      type: String
    },
    failedColor: {
      type: String
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    styles: function styles() {
      var style = {
        width: "".concat(this.percent, "%")
      };
      if (this.status === 'success' && this.color && this.color !== 'success' && this.color !== 'error') {
        style.backgroundColor = this.color;
      }
      if (this.status === 'error' && this.failedColor && this.failedColor !== 'success' && this.failedColor !== 'error') {
        style.backgroundColor = this.failedColor;
      }
      return style;
    },
    innerClasses: function innerClasses() {
      var _ref;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-inner-color-success"), this.status === 'success'), _defineProperty(_ref, "".concat(prefixCls, "-inner-color-error"), this.status === 'error'), _ref;
    }
  }
};